/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './assets/tailwind.css'
import 'helpers/i18n'
import './posthog'
import { Provider } from 'react-redux'
import store from 'helpers/store'
import 'react-toastify/dist/ReactToastify.css'
import ErrorBoundary from 'components/ErrorBoundary'
import { reportError } from 'utils/errorReporter'

window.addEventListener('error', (event) => {
    const err = event?.error || new Error(event?.message || 'Unknown error')
    reportError(err, {
        type: 'window.error',
        source: event?.filename,
        line: event?.lineno,
        col: event?.colno,
    })
})

window.addEventListener('unhandledrejection', (event) => {
    const reason =
        event?.reason instanceof Error
            ? event.reason
            : new Error(
                  typeof event?.reason === 'string'
                      ? event.reason
                      : `Unhandled rejection: ${JSON.stringify(event?.reason)}`
              )
    reportError(reason, { type: 'unhandledrejection' })
})

import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'

const rootElement = document.getElementById('root')

if (!rootElement) {
    throw new Error('Root element with id "root" not found')
}

ReactDOM.createRoot(rootElement).render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </QueryClientProvider>
    </Provider>
)
// Mark app mounted for CI tests and debugging
;(window as any).__app_mounted = true

